module.exports = __webpack_public_path__ + "static/media/check_photo.9defdf9b.png";